/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsSignalComparison = {
  comparable: boolean;
  /**
   * Descriptive difference in observed answer shares, never a significance test
   */
  deltaShare?: number | undefined;
  from: Date;
  /**
   * Failed comparison gates. Coverage remains unknown even when the observed measurements are comparable.
   */
  reasons: Array<string>;
  summary: { [k: string]: any };
  to: Date;
};

/** @internal */
export const AnalyticsSignalComparison$inboundSchema: z.ZodMiniType<
  AnalyticsSignalComparison,
  unknown
> = z.pipe(
  z.object({
    comparable: z.boolean(),
    delta_share: z.optional(z.number()),
    from: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    reasons: z.array(z.string()),
    summary: z.record(z.string(), z.any()),
    to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  }),
  z.transform((v) => {
    return remap$(v, {
      "delta_share": "deltaShare",
    });
  }),
);

export function analyticsSignalComparisonFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalComparison, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalComparison$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalComparison' from JSON`,
  );
}
